<!--Buttons-->
<div class="col-2">
  <button pButton type="button" [label]="'FOLD.ACTION_COMPONENT.EXCLUDE_BUTTON' | translate"
          [disabled]="!enableExclude"
          (click)="loadExclude()" class="p-button-warning"></button>
</div>
<!--Dirty legacy behavior handling-->
<div class="col-2">
  <button pButton type="button"
          [label]="'FOLD.ACTION_COMPONENT.RESTORE_BUTTON' | translate"
          [disabled]="!enableRestore"
          (click)="loadRestore()" class="p-button-warning"></button>
</div>

<!--Confirm or exclude modal-->
<app-multi-action-confirm *ngIf="openMultiActionConfirmModal" [folds]="toProcess" [total]="folds.length" (visible)="handleConfirmOrExcludeModalClose($event)"
                          [kindOfActionConfirm]="userChoiceOfAction"></app-multi-action-confirm>
<!--EConfirm or exclude modal-->
